import { addStyles } from 'ethcss'
import { IStyles, mediaCSS } from 'theme'

const reportStyles: IStyles = {
    button: {
        marginLeft: 10,
    },
    reportsWrapper: {
        zIndex: 2000,
        [mediaCSS.tabMini]: {
            zIndex: 0,
            paddingTop: 50
        }
    },
}

addStyles(reportStyles)
export default reportStyles
